import { AccountOfficer, Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export class AccountOfficerService extends BaseService {
  private api = "accountOfficers";

  async getOfficers(params: {
    pageIndex: number;
    recordCount: number;
    name?: string;
  }): Promise<Result<AccountOfficer[]>> {
    const queryParams = this.ToQueryString(params);
    return this.get(`${this.api}${queryParams}`);
  }

  async getOfficer(id: number): Promise<Result<AccountOfficer>> {
    return this.get(`${this.api}/${id}`);
  }

  async addOrUpdateOfficer(
    params: { name: string },
    id?: number
  ): Promise<Result<AccountOfficer | boolean>> {
    if (id) {
      return this.put(`${this.api}/${id}`, params);
    } else {
      return this.post(`${this.api}`, params);
    }
  }

  async deleteOfficer(id: number): Promise<Result<boolean>> {
    return this.delete(`${this.api}/${id}`);
  }
}

export default new AccountOfficerService();
